import React from "react";
import { Box, Container, Grid, Typography, Paper } from "@mui/material";
import DesignServicesIcon from "@mui/icons-material/DesignServices";
import DevicesIcon from "@mui/icons-material/Devices";
import SpeedIcon from "@mui/icons-material/Speed";
import SearchIcon from "@mui/icons-material/Search";

const featuresData = [
  {
    icon: <DesignServicesIcon sx={{ fontSize: 40, color: "#EE964B" }} />,
    bgColor: "#565254",
    title: "Diseño Personalizado",
    description:
      "Tu sitio web refleja la identidad de tu marca, optimizado para dispositivos móviles y con un estilo profesional que genera confianza.",
  },
  {
    icon: <DevicesIcon sx={{ fontSize: 40, color: "#EE964B" }} />,
    bgColor: "#565254",
    title: "Optimización Multidispositivo",
    description:
      "Totalmente responsive, para que tus huéspedes puedan reservar desde cualquier dispositivo, en cualquier momento.",
  },
  {
    icon: <SpeedIcon sx={{ fontSize: 40, color: "#EE964B" }} />,
    bgColor: "#565254",
    title: "Velocidad y Rendimiento",
    description:
      "Carga rápida y navegación fluida, optimizado para SEO y con excelente rendimiento en motores de búsqueda.",
  },
  {
    icon: <SearchIcon sx={{ fontSize: 40, color: "#EE964B" }} />,
    bgColor: "#565254",
    title: "Posicionamiento en Google",
    description:
      "Preparado para posicionarse en Google y aumentar la visibilidad de tu alojamiento en búsquedas relevantes.",
  },
];

function FeaturesWebsiteBuilder() {
  return (
    <Box
      sx={{
        background: "linear-gradient(180deg, #d2c2f2, #903AF2 50%)",
        color: "#fff",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        height: "100%",
        py: 8,
      }}
    >
      <Container maxWidth="lg">
        {/* Título */}
        <Typography
          variant="h4"
          align="center"
          fontWeight="bold"
          mb={8}
          sx={{
            fontFamily: "'Red Hat Display', sans-serif",
            color: "#ffffff",
          }}
        >
          Sitio Web Profesional para tu Alojamiento
        </Typography>

        {/* Features */}
        <Grid container spacing={4}>
          {featuresData.map((feature, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Paper
                elevation={3}
                sx={{
                  backgroundColor: feature.bgColor,
                  borderRadius: "12px",
                  p: 3,
                  display: "flex",
                  alignItems: "center",
                  gap: 3,
                  transition: "transform 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-5px)",
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "64px",
                    height: "64px",
                  }}
                >
                  {feature.icon}
                </Box>
                <Box>
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    sx={{
                      fontFamily: "'Red Hat Display', sans-serif",
                      color: "#ffffff",
                      fontSize: { xs: "1.1rem", md: "1.25rem" },
                    }}
                  >
                    {feature.title}
                  </Typography>
                  <Typography
                    variant="body2"
                    mt={1}
                    sx={{
                      fontFamily: "'Merriweather Sans', sans-serif",
                      color: "#ffffff",
                    }}
                  >
                    {feature.description}
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default FeaturesWebsiteBuilder;
